import { render } from "./Header2.vue?vue&type=template&id=49c54766&scoped=true"
import script from "./Header2.vue?vue&type=script&lang=js"
export * from "./Header2.vue?vue&type=script&lang=js"

import "./Header2.vue?vue&type=style&index=0&id=49c54766&scoped=true&lang=css"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c54766"]])

export default __exports__